import { useSettingDecentralizePageData } from "@faire/deprecated-retailer-visitor-shared/settings/useSettingDecentralizePageData";
import { useSettingHomeRetailerSearchAPIs } from "@faire/deprecated-retailer-visitor-shared/settings/useSettingHomeRetailerSearchAPIs";
import { useQuery as useHomeRetailerSmallBusinessGrantDatesQuery } from "@faire/web-api--source/endpoints/www/api/home-retailer/small-business-grant-dates/get-hooks";
import { useQuery as useMonolithSmallBusinessGrantDatesQuery } from "@faire/web-api--source/endpoints/www/api/page-data/small-business-grant-dates/get-hooks";
import { IRetailerPageData } from "@faire/web-api--source/faire/home_resource/IRetailerPageData";
import { getGlobalProperty } from "@faire/web/common/globals/getGlobalProperty";

export interface IGrantDates {
  hasActiveCycle: boolean;
  dueDate: string;
  reviewDate: string;
  announcementDate: string;
}

export const useGetGrantDates = (): IGrantDates => {
  const shouldDecentralizePageData = useSettingDecentralizePageData();
  const isHomeRetailer = useSettingHomeRetailerSearchAPIs();
  const {
    data: monolithGrantDatesData = IRetailerPageData.ISmallBusinessGrantDates.build(
      {}
    ),
  } = useMonolithSmallBusinessGrantDatesQuery({
    enabled: shouldDecentralizePageData && !isHomeRetailer,
    refetchOnMount: false,
    staleTime: Infinity,
  });
  const {
    data: homeRetailerGrantDatesData = IRetailerPageData.ISmallBusinessGrantDates.build(
      {}
    ),
  } = useHomeRetailerSmallBusinessGrantDatesQuery({
    enabled: shouldDecentralizePageData && isHomeRetailer,
    refetchOnMount: false,
    staleTime: Infinity,
  });

  let serializedDates: IRetailerPageData.ISmallBusinessGrantDates | undefined;

  if (shouldDecentralizePageData) {
    if (isHomeRetailer) {
      serializedDates = homeRetailerGrantDatesData;
    } else {
      serializedDates = monolithGrantDatesData;
    }
  } else {
    serializedDates = getGlobalProperty(
      "smallBusinessGrantDates"
    ) as IRetailerPageData.ISmallBusinessGrantDates;
  }

  const hasActiveCycle =
    !!serializedDates?.due_date &&
    !!serializedDates?.review_date_range &&
    !!serializedDates?.announcement_date;

  return {
    hasActiveCycle,
    dueDate: serializedDates?.due_date ?? "",
    reviewDate: serializedDates?.review_date_range ?? "",
    announcementDate: serializedDates?.announcement_date ?? "",
  };
};
